export var LINK_CLASS_PREFIX = 'Link';